import termOnePath from '../../lib/termOnePath'

export default ({ form, field }) => (option) =>
  form.setFieldValue(`${termOnePath({ formikProps: form })}.type`, option.value)
